import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Card, CardBody, Container, Form } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { ArrowLeft, ArrowRight } from "react-feather";
import classNames from "classnames";

import { MySpinner } from "components/MySpinner";
import useQuery from "utils/useQuery";
import { getFinanceDashboard } from "services/apiAnalitics";
import { CutLink } from "components/CutLink";
import { priceFormat } from "utils/format";
import { Checkbox } from "components/Checkbox";

import "./financeDashboard.scss";

export const FinanceDashboard = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const query = useQuery(useLocation);
  const [loading, setLoading] = useState(false);
  const [customerReceivables, setСustomerReceivables] = useState([]);
  const [providerPayables, setProviderPayables] = useState([]);
  const [customerRemainingDebt, setCustomerRemainingDebt] = useState([]);
  const [providerRemainingDebt, setProviderRemainingDebt] = useState([]);
  const [total, setTotal] = useState([]);
  const [customerRemainingTotalDebt, setCustomerRemainingTotalDebt] = useState(0);
  const [providerPayablesTotalDebt, setProviderPayablesTotalDebt] = useState([]);
  const [showMorecustomerReceivables, setShowMoreСustomerReceivables] = useState(false);
  const [showMoreProviderPayables, setShowMoreProviderPayables] = useState(false);
  const [selected, setSelected] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    query.get("page") ? Number(query.get("page")) : 1
  );

  const getAndSetFinanceDashboard = () => {
    setLoading(true);
    // toast.success("Генерация отчета запущена");
    getFinanceDashboard({
      offset: (currentPage - 1) * 10
    })
      .then((res) => {
        setСustomerReceivables(res.customerReceivables);
        setProviderPayables(res.providerPayables);
        setCustomerRemainingDebt(res.customerRemainingDebt);
        setProviderRemainingDebt(res.providerRemainingDebt);
        setCustomerRemainingTotalDebt(res.customerRemainingTotalDebt);
        setProviderPayablesTotalDebt(res.providerPayablesTotalDebt);
        setTotal(res.total);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAndSetFinanceDashboard();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const dates = () => {
    const dates = [];
    const start = moment();

    for (let i = ((currentPage - 1) * 10); i < ((currentPage - 1) * 10) + 10; i++) {
      dates.push(start.clone().add(i, 'days').format('DD.MM.YYYY'));
    }
    return dates;
  }

  const summ = (payments) => {
    return priceFormat(payments.reduce((acc, payment) => acc + payment.remainingDebt, 0));
  }

  const paymentRender = (item, date) => {
    console.log(item);
    return Object.entries(item).map(([paymentDate, payments]) => date === moment(paymentDate).format('DD.MM.YYYY') ? summ(payments) : null)
  }

  const paymentSummByDateRender = (pays, date) => {
    const payments = [];
    for (const customer of Object.values(pays)) {
      for (const [paymentDate, payment] of Object.entries(customer)) {
        if (date === moment(paymentDate).format('DD.MM.YYYY')) {
          payments.push(...payment);
        }
      }
    }
    return summ(payments);
  }

  const setPage = (page) => {
    setCurrentPage(prev => (prev + page) < 1 ? 1 : (prev + page));
  }

  const handleSelect = (e, customer) => {
    setSelected((prev) => {
      if (!e.target.checked) {
        prev.splice(
          prev.findIndex((val) => val === customer),
          1
        );
        return [...prev];
      }
      return [...prev, customer];
    });
  }

  const totalRender = (date) => {
    for (const [totalDate, totalDay] of Object.entries(total)) {
      if (date === moment(totalDate).format('DD.MM.YYYY')) {
        return totalDay;
      }
    }
  };

  return (
    <Container fluid className="p-0 analitics-provider">
      {loading && <MySpinner overlay />}
      <Card className="mb-0 filter">
        <CardBody>
          <h1 className="h3 mb-3">Финансовая аналитика (бюджет)</h1>
          <Form className="mb-3">

          </Form>
        </CardBody>
      </Card>

      <Card className="mb-0">
        <CardBody>
          <div className="d-flex justify-content-between">
            <Button onClick={() => setPage(-1)} disabled={currentPage === 1}><ArrowLeft size={15} /></Button>
            <Button onClick={() => setPage(+1)}><ArrowRight size={15} /></Button>
          </div>
        </CardBody>
      </Card>
      <div className="react-bootstrap-table">
        <table className="table table-hover pointer">
          <thead>
            <tr>
              <th></th>
              <th width={38}></th>
              <th></th>
              {dates().map((date) =>
                <th key={date}>
                  {date}
                </th>
              )}
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Приход</td>
              <td></td>
              <td></td>
              {dates().map((date) =>
                <td key={date}>
                  <b>{paymentSummByDateRender(customerReceivables, date)}</b>
                </td>
              )}
              <td><b>{priceFormat(customerRemainingTotalDebt)}</b></td>
            </tr>
            {Object.entries(customerReceivables).slice(0, showMorecustomerReceivables ? Object.entries(customerReceivables).length : 5).map(([customer, item], i) =>
              <tr key={customer} className={classNames({ selected: selected.find(v => v === customer) })}>

                {i === 0 && <td rowSpan={showMorecustomerReceivables ? Object.entries(customerReceivables).length : 5 + 1}></td>}

                <td>
                  <Checkbox
                    name={`select_${customer}`}
                    checked={selected.find(v => v === customer)}
                    onChange={(e) => handleSelect(e, customer)}
                  />
                </td>
                <td>
                  <CutLink>{customer}</CutLink>
                </td>

                {dates().map((date) =>
                  <td key={date}>
                    {paymentRender(item, date)}
                  </td>
                )}
                <td><b>{customerRemainingDebt[customer] ? priceFormat(customerRemainingDebt[customer]) : null}</b></td>
              </tr>
            )}
            <tr>
              <td colSpan={13}><Button onClick={() => setShowMoreСustomerReceivables(prev => !prev)}>{showMorecustomerReceivables ? 'Скрыть' : 'Показать все'}</Button></td>
            </tr>

            <tr>
              <td>Расход</td>
              <td></td>
              <td></td>
              {dates().map((date) =>
                <td key={date}>
                  <b>{paymentSummByDateRender(providerPayables, date)}</b>
                </td>
              )}
              <td><b></b></td>
            </tr>

            {Object.entries(providerPayables).slice(0, showMoreProviderPayables ? Object.entries(providerPayables).length : 5).map(([provider, item], i) =>
              <tr key={provider} className={classNames({ selected: selected.find(v => v === provider) })}>

                {i === 0 && <td rowSpan={Object.entries(providerPayables).length + 1}></td>}

                <td>
                  <Checkbox
                    name={`select_${provider}`}
                    checked={selected.find(v => v === provider)}
                    onChange={(e) => handleSelect(e, provider)}
                  />
                </td>
                <td>
                  <CutLink>{provider}</CutLink>
                </td>

                {dates().map((date) =>
                  <td key={date}>
                    {paymentRender(item, date)}
                  </td>
                )}
                <td><b>
                  {/* {providerRemainingDebt[provider] ? priceFormat(providerRemainingDebt[provider] * -1) : null} */}
                </b></td>
              </tr>
            )}

            <tr>
              <td colSpan={13}><Button onClick={() => setShowMoreProviderPayables(prev => !prev)}>{showMoreProviderPayables ? 'Скрыть' : 'Показать все'}</Button></td>
            </tr>

          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              {dates().map((date) =>
                <td key={date}>
                  <b>{priceFormat(totalRender(date))}</b>
                </td>
              )}
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div >

    </Container >
  )
};